export default __webpack_public_path__ + "static/media/folder-zip.d22ff378.svg";